import React, { Component } from 'react';
import {Col, Alert, Button} from "react-bootstrap";
// import GoogleAd from "../Marketing/GoogleAd";
import {convertDate} from '../../functions/convertDate';
import {convertTime} from "../../functions/convertTime";
import BlogListPagination from "./BlogListPagination";
import {Link} from "react-router-dom";
import {LinkContainer} from "react-router-bootstrap";
import {Storage} from "aws-amplify";
const asyncForEach = async (array, callback) => {
  for (let i = 0; i < array.length; i++) {
    await callback(array[i], i, array);
  }
}
export default class BlogList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogsLoading: true,
      blogList: []
    }
  }
  async componentDidMount(){
    await this.getCoverPhoto(this.props.blogList);
  }

  async getCoverPhoto(blogList) {
    this.setState({blogsLoading: true});
    if (blogList.length > 0) {
      try {
        // get the list of the cover photos
        const coverPhotos = await Storage.list('', {
          level: 'protected',
          identityId: 'blog'
        });
        await asyncForEach(blogList, async (blogDetail) => {
          let coverPhoto = '/blog.jpg';
          // see if there's a cover photo for the iteration of the blog post
          await asyncForEach(coverPhotos, async (pic) => {
            if (pic.key === `${blogDetail.blogUUID}.jpg`) {
              coverPhoto = await Storage.get(pic.key, {
                level: 'protected',
                identityId: 'blog'
              });
              blogDetail.coverPhoto = coverPhoto;
            }
          });
          blogDetail.coverPhoto = coverPhoto;
        });
        this.setState({blogList});
      } catch (e) {
      } finally {
        this.setState({blogsLoading: false});
      }
    } else {
      this.setState({
        blogsLoading: false,
        blogList: []
      });
    }
  }
  renderTags(tags) {
    if (tags) {
      const tagLength = tags.length;
      let tagStyle = {marginTop:5, marginRight:5, verticalAlign:'bottom'};
      return tags.map((tag, i) => {
        if (tagLength === i+1) tagStyle = {marginTop:5, verticalAlign:'bottom'};
        return (
          <LinkContainer
            key={i}
            style={tagStyle}
            to={`../../blog/tag/${encodeURIComponent(tag)}`}>
            <Button bsSize="xsmall"><b>{tag}</b></Button>
          </LinkContainer>
        )
      });
    }
  }
  renderTagName() {
    if (this.props.tag) {
      return (
        <span>
          There weren't any {window.location.pathname.substring(1).split('/')[0]}s found that were tagged: <b><i>{this.props.tag}</i></b>
        </span>
      )
    } else {
      return (
        <span>
          There weren't any blogs found on this page.
      </span>
      )
    }
  }
  renderBlogs() {
    if (this.state.blogList.length > 0) {
      return this.state.blogList.map((blogDetail, i) => {
        return (
          <Col
            className='newblog'
            key={i}
            xs={12}
          >
            <h4 style={{paddingBottom:7, fontWeight:"bold"}}>
              <Link
                style={{fontWeight:'bold'}}
                to={`/blog/${blogDetail.categorySlug}/${blogDetail.blogSlug}`}>
                {blogDetail.blogTitle}
              </Link>
            </h4>
            <Link style={{fontWeight:'bold'}} to={`/blog/${blogDetail.categorySlug}/${blogDetail.blogSlug}`}>
              <img src={blogDetail.coverPhoto} alt={blogDetail.blogTitle}/>
            </Link>
            {blogDetail.categorySlug && blogDetail.categoryTitle && <div>
              <b>
                <i className="fa fa-file-text-o fa-fw" aria-hidden="true"/> Category:
              </b> <Link to={`/blog/${blogDetail.categorySlug}`}>{blogDetail.categoryTitle}</Link>
            </div>}
            {blogDetail.created === blogDetail.updated && <div>
              <b><i className="fa fa-calendar fa-fw" aria-hidden="true"/> Published:</b> {convertDate(blogDetail.created)}
            </div>}
            {blogDetail.created !== blogDetail.updated && <div>
              <b><i className="fa fa-calendar fa-fw" aria-hidden="true"/> Updated:</b> {convertDate(blogDetail.updated)}
            </div>}
            <div>
              <b><i className="fa fa-user-o fa-fw" aria-hidden="true"/> Author:</b> <Link to={`/JasperThayer`}>Jasper Thayer</Link>
            </div>
            {blogDetail.videoDuration && <div>
              <b><i className="fa fa-play-circle-o fa-fw" aria-hidden="true"/></b> {convertTime(blogDetail.videoDuration)}
            </div>}
            {blogDetail.blogTags && <div style={{display:'inherit', marginTop:-4}}>
                <b style={{verticalAlign:'text-bottom', paddingLeft:2}}>
                  <i className="fa fa-tags fa-fw" aria-hidden="true"/> {blogDetail.blogTags.length === 1 ? 'Tagged:' : 'Tags:'}
                </b> {this.renderTags(blogDetail.blogTags)}
            </div>}
            {blogDetail.blogExcerpt && <div style={{marginTop:10}}>
              {blogDetail.blogExcerpt}
            </div>}
          </Col>
        );

        // replace this return with the commented out code below to show ads between categories
        /*return (
          <div key={i}>
             Render these components because they're before an ad
            {(i === 0 || i === 3 || i === 5) && <Col
                className='blog'
                style={{marginBottom:15}}
                xs={12}
                onClick={() => this.props.history.push(`/category/${blogDetail.categoryCategory}`)}
            >
              <Category blogDetail={blogDetail}/>
            </Col>}
             Render ads at these intervals
            {(i === 1 || i === 4 || i === 6) && <Col xs={12}><GoogleAd/></Col>}
             Render these components because they're after an ad
            {(i === 1 || i === 4 || i === 6) && <Col
              className='blog'
              style={{marginTop:15, clear:'both'}}
              xs={12}
              onClick={() => this.props.history.push(`/category/${blogDetail.categoryCategory}`)}
            >
              <Category blogDetail={blogDetail}/>
            </Col>}
             Render these components because they're not before or after an ad
            {(i !== 0 && i !== 1 && i !== 3 && i !== 4 && i !== 5 && i !== 6) && <Col
              className='blog'
              xs={12}
              onClick={() => this.props.history.push(`/category/${blogDetail.categoryCategory}`)}
            >
              <Category blogDetail={blogDetail}/>
            </Col>}
          </div>
        )*/

      });
    } else {
      if (this.props.page) {
        // if it's a page and there's no results,
        // then redirect to the main page to see if there's any posts there for good measure
        if (this.props.tag) {
          this.props.history.push(`/blog/tag/${this.props.tag}`);
        } else if (this.props.category) {
          this.props.history.push(`/blog/${this.props.category}`);
        } else {
          this.props.history.push(`/blog`);
        }
      }
      return (
        <Alert bsStyle="danger">
          <h4><b><i className="fa fa-warning fa-fw" aria-hidden="true"/> Error!</b></h4>
          {this.renderTagName()}
        </Alert>
      );
    }
  }
  render() {
    return (
      <div>
        {!this.state.blogsLoading && <div>
          {this.renderBlogs()}
          {this.state.blogList.length > 0 && <BlogListPagination
            page={Number(this.props.page)}
            category={this.props.category}
            tag={this.props.tag}
            lastEvaluatedKey={this.props.lastEvaluatedKey}
          />}
        </div>}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Blog/BlogList.js